"use client";
import React from "react";
import dynamic from "next/dynamic";
import MapSkeleton from "modules/common/components/skeletons/map/MapSkeleton";
import { LGS } from "modules/lgs/model/lgs";

export interface SimpleMapProps {
  store: LGS;
  className?: string;
}

// Create a dynamic component factory that accepts props for the skeleton
const createDynamicSimpleMap = (
  skeletonProps: Pick<SimpleMapProps, "className">
) => {
  return dynamic(
    () => import("./SimpleMap").then((mod) => ({ default: mod.SimpleMap })),
    {
      loading: () => (
        <MapSkeleton enableSearchBar={false} className={"h-full"} />
      ),
      ssr: false,
    }
  );
};

const DynamicSimpleMap = ({ className, ...props }: SimpleMapProps) => {
  // Create the dynamic component with the current props for the skeleton
  const SimpleMap = React.useMemo(
    () => createDynamicSimpleMap({ className }),
    [className]
  );

  return <SimpleMap className={className} {...props} />;
};

export default DynamicSimpleMap;
